// A game's players and its player setting, as the API returns them.

// The black and white players ({id, displayName}) of a game, from its player setting: in a
// standard game setup.blackPlayer plays black and the other player white (the same player when
// there is only one). Both are null when the setting is incomplete, as on the server.
export function seats(game) {
  const none = { black: null, white: null };
  if(!game || !game.setup || game.setup.type !== 'standard') return none;
  const players = game.players || [];
  const black = players.find(p => p.id === game.setup.blackPlayer);
  if(!black) return none;
  if(players.length === 1) return { black, white: black };
  if(players.length !== 2) return none;
  const white = players.find(p => p !== black);
  return white.id !== black.id ? { black, white } : none;
}
